import { combineReducers } from 'redux';

import { templatesReducer } from './templates/templatesReducer';
import { twitterConnectionReducer } from './twitter-connection/twitterConnectionReducer';

const UserReducer = combineReducers({
  templates: templatesReducer,
  twitterConnection: twitterConnectionReducer,
});

export default UserReducer;
